/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Tiles_portfolioItemsConnection$ref = any;
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type ItemsRefetchWrapper_portfolioNode$ref = any;
export type ItemsRefetchWrapper_portfolioNode = {
    readonly id: string;
    readonly serviceId: string | null;
    readonly portfolioItems: {
        readonly totalResults: number | null;
        readonly numberOfPages: number | null;
        readonly pageInfo: {
            readonly hasNextPage: boolean;
            readonly endCursor: string | null;
        };
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
                readonly item: {
                    readonly serviceId: string | null;
                    readonly vertical: VerticalType | null;
                    readonly seller: {
                        readonly serviceId: string | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": Tiles_portfolioItemsConnection$ref;
    } | null;
    readonly " $refType": ItemsRefetchWrapper_portfolioNode$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ItemsRefetchWrapper_portfolioNode",
        "type": "PortfolioV2",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "first",
                "type": "Int"
            },
            {
                "kind": "RootArgument",
                "name": "after",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "searchTerm",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "sortBy",
                "type": "PortfolioItemsSortByTypes"
            },
            {
                "kind": "RootArgument",
                "name": "page",
                "type": "Int"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": "portfolioItems",
                "name": "items",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "after",
                        "variableName": "after"
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    },
                    {
                        "kind": "Variable",
                        "name": "page",
                        "variableName": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "searchTerm",
                        "variableName": "searchTerm"
                    },
                    {
                        "kind": "Variable",
                        "name": "sortBy",
                        "variableName": "sortBy"
                    }
                ],
                "concreteType": "PortfolioItemsConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalResults",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "numberOfPages",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioItemsEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PortfolioItemV2",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "item",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Item",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "vertical",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "seller",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "Seller",
                                                "plural": false,
                                                "selections": [
                                                    (v0 /*: any*/)
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "Tiles_portfolioItemsConnection",
                        "args": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '475ed2fee9a032988bff4d03a8ada46a';
export default node;
